import { Link } from 'react-router-dom'
import { useDocumentTitle } from '@/lib/useDocumentTitle'
import { t } from '@/lib/ui'

// SpecPlaceholder/GraphPlaceholder removed — WP-F5 ships the real /spec/:id
// and /graph. WalkPlaceholder was already removed by WP-F1.

export function NotFound() {
  useDocumentTitle('404')
  return (
    <div className="mx-auto max-w-shell px-4 py-24">
      <div className="mx-auto max-w-prose">
        <p className="font-mono text-sm text-muted">404</p>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight text-ink">
          Sivua ei löytynyt
        </h1>
        <p className="mt-3 text-lg text-muted">
          Etsimääsi sivua ei ole. ArkkiKELA on arkkityyppinen tutkimusmalli — tarkista osoite tai palaa etusivulle.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-1.5 text-accent underline decoration-hairline underline-offset-2 hover:decoration-accent"
        >
          ← {t('underConstruction.back')}
        </Link>
      </div>
    </div>
  )
}
